import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
} from "react";
import { useParams, useHistory } from "react-router";
import {
  Grid,
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Loader from "../../components/Loader";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useGetRoomTypeLinks from "../../queries/roomType/getRoomTypeLinks";
import useCreateRoomType from "../../mutation/roomType/createRoomType";
import RMSRoomTypes from "../../components/roomTypes/RMSRoomTypes";
import WordpressSuites from "../../components/roomTypes/WordpressSuites";

import useProperty from "../../queries/property/getProperties";
import useCreateAudit from "../../mutation/audit/createAudit";

import handleRoomTypeDetails from "../../utils/handleRoomTypeDetails";
import { AuthContext } from "../../utils/userProvider";

const errorTextSx = {
  mx: 1.75,
  mt: 0.375,
  fontSize: "0.75rem",
  fontWeight: 400,
  color: "secondary.main",
};

const imageLabelSx = {
  fontSize: 16,
  fontWeight: "bold",
};
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  property: yup.object().required("A Property must be selected."),
  monthlyRent: yup
    .number()
    .typeError("Monthly Rent must be a number")
    .min(0, "Monthly Rent cannot be negative")
    .nullable(true),
  utilitiesFee: yup
    .number()
    .typeError("Utilities Fee must be a number")
    .min(0, "Utilities Fee cannot be negative")
    .nullable(true),
  otherCharges: yup
    .number()
    .typeError("Other Charges must be a number")
    .min(0, "Other Charges cannot be negative")
    .nullable(true),
  display_name: yup.string().nullable(true),
  apartment_type: yup
    .string()
    .nullable(true)
    .test(
      "apartment_type",
      "Invalid apartment type",
      (v) => !v || v === "studio" || v === "shared"
    ),
});

const NewLink = (props) => {
  const history = useHistory();

  const [auditResponse, setAuditData] = useCreateAudit();
  const { authState, setAuthState } = useContext(AuthContext);

  const [rmsTable, setRmsTable] = useState([]);
  const [linkedRoomTypeIdsText, setLinkedRoomTypeIdsText] = useState("");
  const [linkedRoomTypeIdsManuallyEdited, setLinkedRoomTypeIdsManuallyEdited] =
    useState(false);
  const [wordpressSuitesTable, setWordpressSuitesTable] = useState([]);

  const [linkResponse, resetLink] = useGetRoomTypeLinks();
  const [propertyResponse, resetProperty] = useProperty();

  const [tagOptions, setTagOptions] = useState([]);

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const [propertyOptions, setPropertyOptions] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState();

  const propertyChange = (value) => {
    if (value != null) {
      setValue("property", { label: value.label, value: value.value });

      setSelectedProperty(value.value);
      if (propertyResponse.data) {
        let selectedProperty = propertyResponse.data.find(
          (item) => item.id == value.value
        );
        Swal.fire({
          title: "Retrieving Room Type Details",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          showConfirmButton: false,
        });
        Swal.showLoading();
        handleRoomTypeDetails(
          {
            clientId: selectedProperty.clientId,
            clientPassword: selectedProperty.clientPassword,
          },
          authState ? authState.jwt : "",
          (response) => {
            setRmsTable([...response.data]);
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });
            Toast.fire({
              icon: "success",
              title: "Retrieved Room Types",
            });
          },
          (err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.message,
            });
          }
        );
      }
    }
  };

  useEffect(() => {
    if (propertyResponse.data) {
      let data = propertyResponse.data;
      let propertyOptions = [];
      for (var i = 0; i < data.length; i++) {
        let property = data[i];
        propertyOptions.push({
          label: property.name,
          value: property.id,
        });
      }

      setPropertyOptions(propertyOptions);
      setWordpressSuitesTable(
        data.map((p) => ({
          id: p.id,
          name: p.name,
          suiteIds: p.suiteIds,
        }))
      );
    }
  }, [propertyResponse]);

  // useEffect(() => {
  //   if (roomTypeResponse.data) {
  //     setRmsTable([...roomTypeResponse.data]);
  //   }
  // }, [roomTypeResponse]);

  useEffect(() => {
    if (linkResponse.data) {
      let data = linkResponse.data;
      let tagOptions = [];
      for (var i = 0; i < data.length; i++) {
        let tags = data[i].tags;
        for (var a = 0; a < tags.length; a++) {
          if (!tagOptions.includes(tags[a].name)) {
            tagOptions.push(tags[a].name);
          }
        }
      }
      let creatableOptions = [];
      for (var i = 0; i < tagOptions.length; i++) {
        creatableOptions.push({
          label: tagOptions[i],
          value: tagOptions[i],
        });
      }
      setTagOptions(creatableOptions);
    }
  }, [linkResponse]);



  let [rmsCloudError, setRmsCloudError] = useState();
  let [linkedRoomTypeIdsError, setLinkedRoomTypeIdsError] = useState();
  let [wordpressSuitesError, setWordpressSuitesError] = useState();

  const goBack = () => {
    window.location.href = "/dashboard/roomtypes";
  };

  /* const requirementChange = (value) => {
    if (value != null) {
      setValue("requirement", { label: value.label, value: value.value });
    }
  }; */

  const onSubmit = (values) => {
    let complete = true;
    const arrayLinked = linkedRoomTypeIdsText
      .split(",")
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !isNaN(n));
    if (arrayLinked.length === 0) {
      complete = false;
      setLinkedRoomTypeIdsError("Please enter at least one Linked Room Type ID");
    } else {
      setLinkedRoomTypeIdsError(null);
    }
    if (selectedWordpressSuites.length < 1) {
      complete = false;
      setWordpressSuitesError("Please select a Suite(s)");
    }
    if (!selectedRMS) {
      complete = false;
      setRmsCloudError("Please select a Room Type");
    }
    if (complete) {
      let dataObj = {};
      dataObj.wordpress = { ids: arrayLinked };
      let arraySuites = [];
      let propsWithoutSuiteIds = [];
      for (var i = 0; i < selectedWordpressSuites.length; i++) {
        let prop = selectedWordpressSuites[i];
        if (prop.suiteIds?.ids && Array.isArray(prop.suiteIds.ids)) {
          for (var j = 0; j < prop.suiteIds.ids.length; j++) {
            let sid = typeof prop.suiteIds.ids[j] === "number" ? prop.suiteIds.ids[j] : parseInt(prop.suiteIds.ids[j], 10);
            if (!isNaN(sid) && !arraySuites.includes(sid)) {
              arraySuites.push(sid);
            }
          }
        } else {
          propsWithoutSuiteIds.push(prop.name || prop.id);
        }
      }
      if (propsWithoutSuiteIds.length > 0) {
        setWordpressSuitesError(
          `The following properties have no Suite ID(s) configured. Please add suite IDs in the Property tab first: ${propsWithoutSuiteIds.join(", ")}`
        );
        return;
      }
      if (arraySuites.length === 0) {
        setWordpressSuitesError("No valid suite IDs found. Please ensure selected properties have Suite IDs configured in the Property tab.");
        return;
      }
      dataObj.suites = { ids: arraySuites };

      dataObj.rmsId = selectedRMS.id.toString();
      dataObj.name = values.name;
      dataObj.monthlyRent =
        values.monthlyRent !== undefined && values.monthlyRent !== ""
          ? parseFloat(values.monthlyRent)
          : null;
      dataObj.utilitiesFee =
        values.utilitiesFee !== undefined && values.utilitiesFee !== ""
          ? parseFloat(values.utilitiesFee)
          : null;
      dataObj.otherCharges =
        values.otherCharges !== undefined && values.otherCharges !== ""
          ? parseFloat(values.otherCharges)
          : null;

      const trimmedDisplay =
        values.display_name !== undefined && values.display_name !== null
          ? String(values.display_name).trim()
          : "";
      dataObj.display_name = trimmedDisplay !== "" ? trimmedDisplay : null;
      dataObj.apartment_type =
        values.apartment_type && values.apartment_type !== ""
          ? values.apartment_type
          : null;

      let tags = [];
      if (values.tags) {
        for (var i = 0; i < values.tags.length; i++) {
          tags.push({
            name: values.tags[i].value,
          });
        }
        dataObj.tags = tags;
      }

      dataObj.property = selectedProperty;
      Swal.fire({
        title: "Create Updates",
        html: `<h4>Please provide a description before submitting your changes</h4>
        <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
        confirmButtonText: "Confirm",
        focusConfirm: false,
        preConfirm: () => {
          const actionDescription =
            Swal.getPopup().querySelector("#actionDescription").value;
          if (!actionDescription) {
            Swal.showValidationMessage(`Please enter description`);
          }
          return {
            actionDescription: actionDescription,
            newData: dataObj,
            type: "room-type",
            action: "create",
          };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setAuditData(result.value);
        }
      });
    }
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Room Type Link Audit Created",
        });
        history.push("/dashboard/roomtypes");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          if (message == "Already Taken") {
            let itemTaken = "<ul>";
            if (messageData.rms) {
              itemTaken += `<li>${selectedRMS.name} (from RMS Cloud)</li>`;
            }
            /* let wordpressTaken = messageData.wordpress;
            for (var i = 0; i < wordpressTaken.length; i++) {
              itemTaken += `<li>${
                selectedWordpress.find(
                  (element) => element.id.toString() == wordpressTaken[i]
                ).name
              } (From Wordpress)</li>`;
            } */

            itemTaken += "</ul>";

            Swal.fire({
              icon: "error",
              title: "Error",
              html:
                "<p>The following Room Types have already been linked in the system. Please select other Room Types to link.</p>" +
                itemTaken,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: auditResponse.errorMessage.message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.errorMessage.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const [selectedWordpressSuites, setSelectedWordpressSuites] = useState([]);
  const [selectedRMS, setSelectedRMS] = useState();

  const handleWordpressSuitesSelected = ({
    allSelected,
    selectedCount,
    selectedRows,
  }) => {
    setSelectedWordpressSuites(selectedRows);
  };

  const handleRMSSelected = ({ allSelected, selectedCount, selectedRows }) => {
    setSelectedRMS(selectedRows[0]);
  };

  const getExistingLinkedIds = () => {
    const existing = new Set();
    if (linkResponse.data && Array.isArray(linkResponse.data)) {
      linkResponse.data.forEach((l) => {
        if (l.wordpress?.ids && Array.isArray(l.wordpress.ids)) {
          l.wordpress.ids.forEach((id) => {
            const num = typeof id === "number" ? id : parseInt(id, 10);
            if (!isNaN(num)) existing.add(num);
          });
        }
      });
    }
    return existing;
  };

  const generateRoomTypeIdForSuite = (suiteId, rmsId, existing) => {
    const suiteStr = String(suiteId);
    const prefix = parseInt(suiteStr.substring(0, 3), 10);
    if (isNaN(prefix)) return null;
    const rmsNum = parseInt(String(rmsId), 10);
    const rmsSuffix = !isNaN(rmsNum) ? Math.abs(rmsNum) % 100 : 0;
    let candidate = prefix * 100 + rmsSuffix;
    let guard = 0;
    while (existing.has(candidate) && guard < 100) {
      candidate += 1;
      if (candidate >= (prefix + 1) * 100) candidate = prefix * 100;
      guard += 1;
    }
    existing.add(candidate);
    return candidate;
  };

  useEffect(() => {
    if (
      linkedRoomTypeIdsManuallyEdited ||
      !selectedRMS ||
      selectedWordpressSuites.length === 0
    ) {
      return;
    }
    const existing = getExistingLinkedIds();
    const allSuiteIds = [];
    selectedWordpressSuites.forEach((prop) => {
      if (prop.suiteIds?.ids && Array.isArray(prop.suiteIds.ids)) {
        prop.suiteIds.ids.forEach((id) => {
          const num = typeof id === "number" ? id : parseInt(id, 10);
          if (!isNaN(num) && !allSuiteIds.includes(num)) allSuiteIds.push(num);
        });
      }
    });
    const newIds = [];
    allSuiteIds.forEach((sid) => {
      const generated = generateRoomTypeIdForSuite(
        sid,
        selectedRMS?.id,
        existing
      );
      if (generated != null) newIds.push(generated);
    });
    if (newIds.length > 0) {
      setLinkedRoomTypeIdsText(newIds.join(", "));
      setLinkedRoomTypeIdsError(null);
    }
  }, [selectedRMS, selectedWordpressSuites, linkResponse.data]);

  const tagChange = (value) => {
    setValue("tags", value);
  };

  const renderContent = () => {
    return (
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ width: "100%" }}
      >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormPageCard>
                <FormPageHeader
                  title="New Room Type Link"
                  onBack={goBack}
                  subtitle="Please fill in the required fields."
                />
                <TextField
                  name="name"
                  margin="normal"
                  fullWidth
                  label="Name*"
                  variant="outlined"
                  inputRef={register}
                  error={errors.name != null}
                  helperText={errors.name != null ? errors.name.message : null}
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="display_name"
                  margin="normal"
                  fullWidth
                  label="Display name"
                  variant="outlined"
                  inputRef={register}
                  error={errors.display_name != null}
                  helperText={
                    errors.display_name != null
                      ? errors.display_name.message
                      : "Shown to guests (e.g. on booking flows)."
                  }
                  disabled={auditResponse.loading}
                />
                <Controller
                  name="apartment_type"
                  control={control}
                  defaultValue=""
                  render={({ onChange, value }) => (
                    <TextField
                      name="apartment_type"
                      margin="normal"
                      fullWidth
                      select
                      label="Apartment type"
                      variant="outlined"
                      value={value ?? ""}
                      onChange={(e) => onChange(e.target.value)}
                      error={errors.apartment_type != null}
                      helperText={
                        errors.apartment_type != null
                          ? errors.apartment_type.message
                          : null
                      }
                      disabled={auditResponse.loading}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value="studio">Studio</MenuItem>
                      <MenuItem value="shared">Shared</MenuItem>
                    </TextField>
                  )}
                />
                <Typography component="h2" variant="h6" sx={{ mt: 2 }}>
                  HK Pricing Configuration
                </Typography>
                <TextField
                  name="monthlyRent"
                  margin="normal"
                  fullWidth
                  label="Monthly Rent"
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  error={errors.monthlyRent != null}
                  helperText={
                    errors.monthlyRent != null ? errors.monthlyRent.message : null
                  }
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="utilitiesFee"
                  margin="normal"
                  fullWidth
                  label="Utilities Fee"
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  error={errors.utilitiesFee != null}
                  helperText={
                    errors.utilitiesFee != null ? errors.utilitiesFee.message : null
                  }
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="otherCharges"
                  margin="normal"
                  fullWidth
                  label="Other Charges"
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  error={errors.otherCharges != null}
                  helperText={
                    errors.otherCharges != null ? errors.otherCharges.message : null
                  }
                  disabled={auditResponse.loading}
                />
                <Typography component="p" sx={imageLabelSx}>
                  Tags (For Room Categorization)
                </Typography>
                {(tagOptions.length > 0 || !linkResponse.loading) && (
                  <div>
                    <Controller
                      name="tags"
                      control={control}
                      render={({ ...props }) => {
                        return (
                          <CreatableSelect
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                borderColor: errors.tags
                                  ? "red"
                                  : provided.borderColor,
                              }),
                            }}
                            isMulti
                            options={tagOptions}
                            onChange={tagChange}
                            disabled={auditResponse.loading}
                          />
                        );
                      }}
                    />
                    {errors.tags && (
                      <Box sx={errorTextSx}>
                        {errors.tags.message}
                      </Box>
                    )}
                  </div>
                )}
                <div>
                  <Typography component="p" sx={imageLabelSx}>
                    Property
                  </Typography>
                  <div>
                    <Controller
                      name="property"
                      control={control}
                      render={({ ...props }) => {
                        return (
                          <Select
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                borderColor: errors.type
                                  ? "red"
                                  : provided.borderColor,
                              }),
                            }}
                            options={propertyOptions}
                            onChange={propertyChange}
                            disabled={auditResponse.loading}
                          />
                        );
                      }}
                    />
                    {errors.property && (
                      <Box sx={errorTextSx}>
                        {errors.property.message}
                      </Box>
                    )}
                  </div>
                </div>
              </FormPageCard>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormPageCard sx={{ height: 560 }}>
                <Typography component="h1" variant="h5">
                  RMS Cloud Room Types
                </Typography>
                <p>Please select a Room Type from RMS Cloud</p>
                <RMSRoomTypes
                  onSelectedRowsChange={handleRMSSelected}
                  data={rmsTable}
                  selectedRow={selectedRMS}
                  disabled={auditResponse.loading}
                />
                {rmsCloudError && (
                  <Box sx={errorTextSx}>{rmsCloudError}</Box>
                )}
              </FormPageCard>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormPageCard>
                <Typography component="h1" variant="h5">
                  Linked Room Type IDs
                </Typography>
                <p>
                  Auto-generated from the selected Suite ID (first 3 digits)
                  and the RMS Room Type ID (last 2 digits). You can override or
                  add more IDs, separated by commas.
                </p>
                <TextField
                  fullWidth
                  label="Linked Room Type IDs (comma-separated)"
                  variant="outlined"
                  value={linkedRoomTypeIdsText}
                  onChange={(e) => {
                    setLinkedRoomTypeIdsText(e.target.value);
                    setLinkedRoomTypeIdsManuallyEdited(true);
                  }}
                  disabled={auditResponse.loading}
                  placeholder="e.g. 38245, 42112"
                  error={!!linkedRoomTypeIdsError}
                  helperText={linkedRoomTypeIdsError || null}
                />
              </FormPageCard>
            </Grid>
            <Grid item xs={12}>
              <FormPageCard>
                <Typography component="h1" variant="h5">
                  Suites
                </Typography>
                <p>
                  Please select the Suite(s) that correspond to this Room Type.
                </p>
                <WordpressSuites
                  onSelectedRowsChange={handleWordpressSuitesSelected}
                  data={wordpressSuitesTable}
                  selectedRows={selectedWordpressSuites}
                  disabled={auditResponse.loading}
                  showSuiteId
                />
                {wordpressSuitesError && (
                  <Box sx={errorTextSx}>
                    {wordpressSuitesError}
                  </Box>
                )}
              </FormPageCard>
            </Grid>
            <Grid item xs={12}>
              <FormPageCard>
                <FormActions>
                  <Button
                    type="submit"
                    size="large"
                    variant="contained"
                    color="primary"
                    disabled={auditResponse.loading}
                  >
                    Submit
                  </Button>
                </FormActions>
              </FormPageCard>
            </Grid>
          </Grid>
        </Box>
    );
  };

  return (
    <FormPageShell>
      {(linkResponse.loading || propertyResponse.loading) && (
        <FormPageCard>
          <Loader />
        </FormPageCard>
      )}
      {!linkResponse.loading && !propertyResponse.loading && renderContent()}
    </FormPageShell>
  );
};

export default NewLink;
